import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedTasks } from '@hooks/mocks/tasks'
import { useFindProfile } from '@hooks/profile'
import { useSiteFeatures } from '@hooks/siteFeatures'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'
import { api } from '@services/apiClient'

interface ITaskResult {
  count: number
  totalCount: number
  values: IGenericTask[]
}

interface IFetchParams {
  startDate: Date
  endDate: Date
  view: 'midstream' | 'mechanical' | 'process'
}

export function useFindTasks({ startDate, endDate, view }: IFetchParams) {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const { isMidstreamProcess } = useSiteFeatures()
  const siteId = user?.selectedSite.id ?? -1

  const top = 9999
  const viewType = isMidstreamProcess ? 'midstream' : view
  const skipFilter = false

  async function fetchTasks() {
    if (!isMockEnvironment) {
      const uri = `/sites/${siteId}/tasks`

      const { data } = await api.get<ITaskResult>(uri, {
        params: {
          top,
          viewType,
          skipFilter,
          startDate,
          endDate,
        },
      })
      return data.values
    }
    return mockedTasks.values
  }

  return useQuery({
    queryFn: fetchTasks,
    queryKey: ['TASKS', startDate.getTime()],
    enabled: siteId > 0,
  })
}
